import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import ReelsSection from '../../components/reels-section';

export default function Reels() {
    return (
        <div className="min-h-screen bg-[#f4f7fa]">
            <Navbar transparent={false} />
            <div className="container mx-auto px-4 pt-24 pb-20">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-black text-primary-dark uppercase tracking-tight mb-4">Property Reels</h2>
                    <p className="text-gray-500 font-bold max-w-2xl mx-auto">Explore premium properties through immersive video tours and shorts.</p>
                </div>
                <ReelsSection />
            </div>
            <Footer />
        </div>
    );
}
